import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import axiosInstance from '../api/axiosInstance';


const ProjectsCreated = ({ teamId }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchChartData = async () => {
      if (!teamId) return; // Prevent API call if teamId is missing
  
      try {
        const response = await axiosInstance.get(`/api/team/projects/${teamId}`);
        const data = response.data;
  
        if (!Array.isArray(data)) {
          console.warn("Unexpected response format for charts data:", data);
          setChartData([]);
          return;
        }
  
        // Format data for Highcharts and convert date to timestamp
        const formattedData = data.map(item => ({
          date: new Date(item.created_date).getTime(), // Convert date to timestamp
          chartsCreated: item.charts_created,
        }));
  
        setChartData(formattedData);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          console.warn("No charts found for team", teamId);
          setChartData([]); 
        } else {
          console.error("Error fetching charts created data:", error);
        }
      }
    };
  
    fetchChartData();
  }, [teamId]);
  

  const options = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    colors: [
      '#28277E',
      '#6D5BD1',
    ],
    xAxis: {
      type: 'datetime',
    },
    yAxis: {
      title: {
        text: ''
      },
    },
    legend:{
      enabled:false
    },
    credits:{
        text:''
    },
    tooltip: {
      formatter: function() {
        return  '<b>' + this.series.name + '</b><br/>' +
                Highcharts.dateFormat('%d-%m-%Y', this.x) 
            + ' date, ' + this.y + ' projects.';
      }
    },
    series: [
      {
        name: 'Projects Created',
        data: chartData.map(item => [item.date, item.chartsCreated]), 
      },
    ],
  };

  return (
    <div>
      <h3>Charts Created Over Time</h3>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default ProjectsCreated;
